import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ParaMilestoneStatusStripComponent } from './para-milestone-status-strip.component';
import { ParaMilestoneIconModule } from '../para-milestone-icon/para-milestone-icon.module';

@NgModule({
	imports: [CommonModule, ParaMilestoneIconModule],
	declarations: [ParaMilestoneStatusStripComponent],
	exports: [ParaMilestoneStatusStripComponent],
})
export class ParaMilestoneStatusStripModule {}
